import { Button, Form, Input, Modal } from 'antd';

import { Error403Unauthorized, Phone } from '@app/components';
import { FORBIDDEN_ERROR_MAIN_PART } from '@app/constants';
import { PF } from '@app/pages/Warehouses/Suppliers/components/AddEditSupplier/data';
import {
  useAddEditSupplier,
  useAddEditSupplierEffects,
} from '@app/pages/Warehouses/Suppliers/components/AddEditSupplier/hooks';
import type { AddEditSupplierType } from '@app/pages/Warehouses/Suppliers/components/AddEditSupplier/types';

import '@pages/Warehouses/Suppliers/components/AddEditSupplier/styles/AddEditSupplier.scss';

const { Item } = Form;
const { TextArea } = Input;

export const AddEditSupplier: AddEditSupplierType = ({ mode = 'add' }) => {
  const {
    form,
    initForm,
    onFinish,
    openDeleteModal,
    closeDeleteModal,
    onDelete,
    isDeleteOpen,
    onCancel,
    disabledForm,
    skipForm,
    setPhoneValidation,
    initialValues,
    IsSupplierDelete,
    isPageForbidden,
  } = useAddEditSupplier({ mode });

  useAddEditSupplierEffects({ initForm, skipForm });

  if (isPageForbidden) {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  return (
    <>
      <div className={`${PF}_container`}>
        <Form
          form={form}
          layout="horizontal"
          labelAlign="left"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 10 }}
          className={`${PF}_form`}
          name={`${PF}_form`}
          onFinish={onFinish}
          initialValues={initialValues}
        >
          <Item
            name="Name"
            label="Название"
            rules={[
              { required: true, message: 'Введите название поставщика' },
              {
                max: 200,
                message: 'Максимальная длина названия 200 символов',
              },
              {
                min: 3,
                message: 'Минимальная длина названия 3 символа',
              },
            ]}
          >
            <Input
              type="text"
              placeholder="Введите название"
              disabled={disabledForm}
            />
          </Item>
          <Item name="Phone" label="Телефон">
            <Phone
              name="Phone"
              onValidate={setPhoneValidation}
              disabled={disabledForm}
              required={false}
            />
          </Item>
          <Item
            name="Comment"
            label="Примечание"
            rules={[
              {
                max: 4000,
                message: 'Максимальная длина примечания 4000 символов',
              },
            ]}
          >
            <TextArea
              placeholder="Введите примечание поставщика"
              rows={6}
              disabled={disabledForm}
            />
          </Item>

          <div className={`${PF}_buttons`}>
            <Button
              type="primary"
              htmlType="submit"
              className={`${PF}_buttons_item`}
              disabled={disabledForm}
              loading={disabledForm}
            >
              Сохранить
            </Button>
            <Button
              type="default"
              className={`${PF}_buttons_item`}
              onClick={onCancel}
              disabled={disabledForm}
            >
              Отменить
            </Button>
            {mode === 'edit' && IsSupplierDelete && (
              <Button
                danger
                className={`${PF}_buttons_item`}
                onClick={openDeleteModal}
                disabled={disabledForm}
              >
                Удалить
              </Button>
            )}
          </div>
        </Form>
      </div>
      <Modal
        title="Удаление бренда"
        open={isDeleteOpen}
        onCancel={closeDeleteModal}
        onOk={onDelete}
        okText="Удалить"
        cancelText="Отмена"
        okButtonProps={{
          danger: true,
          disabled: disabledForm,
          loading: disabledForm,
        }}
        cancelButtonProps={{ disabled: disabledForm }}
      >
        <p>Вы уверены, что хотите удалить этого поставщика?</p>
      </Modal>
    </>
  );
};
